import React, { useState } from "react";
import { Modal, Form, Button, Alert, Spinner } from "react-bootstrap";
import CampoPassword from "./CampoPassword";
import * as perfilApi from "../api/perfil";

export default function ModalCambiarPassword({ show, onHide }) {
  const [passwordActual, setPasswordActual] = useState("");
  const [passwordNueva, setPasswordNueva] = useState("");
  const [confirmarPasswordNueva, setConfirmarPasswordNueva] = useState("");
  const [error, setError] = useState("");
  const [exito, setExito] = useState(false);
  const [guardando, setGuardando] = useState(false);

  const limpiar = () => {
    setPasswordActual("");
    setPasswordNueva("");
    setConfirmarPasswordNueva("");
    setError("");
    setExito(false);
    setGuardando(false);
  };

  const handleHide = () => {
    limpiar();
    onHide();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (passwordNueva !== confirmarPasswordNueva) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    setGuardando(true);
    try {
      await perfilApi.cambiarPassword(passwordActual, passwordNueva, confirmarPasswordNueva);
      setExito(true);
    } catch (err) {
      setError(err.response?.data?.mensaje || "No se pudo cambiar la contraseña.");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Modal show={show} onHide={handleHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Cambiar contraseña</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {exito ? (
          <>
            <Alert variant="success" className="py-2 mb-3">Contraseña actualizada correctamente.</Alert>
            <div className="text-end">
              <Button variant="primary" onClick={handleHide}>Cerrar</Button>
            </div>
          </>
        ) : (
          <Form onSubmit={handleSubmit}>
            {error && <Alert variant="danger" className="py-2">{error}</Alert>}
            <CampoPassword
              label="Contraseña actual"
              value={passwordActual}
              onChange={(e) => setPasswordActual(e.target.value)}
              autoComplete="current-password"
            />
            <CampoPassword
              label="Contraseña nueva"
              value={passwordNueva}
              onChange={(e) => setPasswordNueva(e.target.value)}
              autoComplete="new-password"
            />
            <CampoPassword
              label="Confirmar contraseña"
              value={confirmarPasswordNueva}
              onChange={(e) => setConfirmarPasswordNueva(e.target.value)}
              autoComplete="new-password"
            />
            <Form.Text className="text-muted d-block mb-3" style={{ marginTop: "-0.75rem" }}>
              Mínimo 8 caracteres, incluyendo letras y números.
            </Form.Text>
            <div className="text-end">
              <Button type="submit" variant="primary" disabled={guardando}>
                {guardando ? <Spinner size="sm" animation="border" /> : "Guardar"}
              </Button>
            </div>
          </Form>
        )}
      </Modal.Body>
    </Modal>
  );
}
